<template>
  <a
    :rel="rel"
    :target="target"
    :href="href"
    @click="onClick($event)"
    :class="{underline: underline}"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'LinkButton',
  props: {
    href: {
      type: String,
      default: '#',
    },
    preventDefault: {
      type: Boolean,
      default: true,
    },
    target: {
      type: String,
      default: '_self',
    },
    rel: {
      type: String,
      default: 'noopener',
    },
    underline: Boolean,
  },
  methods: {
    onClick($event) {
      if (this.preventDefault) $event.preventDefault();
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
a {
  font-size: 12px;
  color: #ff5f3c;
  text-decoration: none;

  &.underline {
    padding-bottom: 1px;
    text-decoration: none;
    border-bottom: 2px solid #ff5f3c;

    &:hover {
      text-decoration: none;
      border-bottom: 2px solid rgba(255, 95, 60, 0.6);
    }
  }
}
a:hover {
  text-decoration: underline;
}
</style>
